import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {formatDate} from '@angular/common';
import {DadService} from '../../../services/dad.service';
import {saveAs} from 'file-saver';

@Component({
  selector: 'app-csv-report',
  templateUrl: './csv-report.component.html',
  styleUrls: ['./csv-report.component.scss']
})
export class CsvReportComponent implements OnInit {

  @Input() exchangeNamesList: any[];
  @Output() errorCsvReport = new EventEmitter<boolean>();
  @Output() errorMessageCsvReport = new EventEmitter<string>();
  csvSelectedOption = {exchange: '', mode: '', date: ''};
  error = false;
  csvOptions = [{label: 'Draft', value: 'Draft'}, {label: 'Final', value: 'Final'}];
  usageMonth = [];

  constructor(private dadService: DadService) {
  }

  ngOnInit() {
    this.initializeFilters();
  }

  private initializeFilters() {
    const dateOption = new Date();
    dateOption.setDate(3);
    dateOption.setMonth(dateOption.getMonth());
    for (let _i = 1; _i < 37; _i++) {
      this.usageMonth.push({
        label: formatDate(new Date(dateOption), 'MMMM y', 'en-US'),
        value: new Date(dateOption).toISOString()
      });
      dateOption.setMonth(dateOption.getMonth() - 1);
    }
    this.csvSelectedOption = {
      exchange: 'TheICE',
      mode: 'Draft',
      date: this.usageMonth[0].value
    };
  }

  exportCSV() {
    this.errorCsvReport.emit(false);
    this.dadService.dadReport(this.csvSelectedOption).subscribe({
      next: res => {
        // for euronext and LME the reports are Excel, and for other exchanges it's CSV.
        const extension = ['Euronext', 'LME', 'LSE', 'TURQ'].includes(this.csvSelectedOption.exchange) ? '.xlsx' : '.csv';
        const reportName = this.csvSelectedOption.exchange
          + '_' + formatDate(this.csvSelectedOption.date, 'yyyy-MM-01', 'en-US')
          + '_' + this.csvSelectedOption.mode + extension;
        this.downLoadFile(res, reportName);
      }, error: error => {
        this.errorCsvReport.emit(true);
        if (error.status === 400) {
          this.errorMessageCsvReport.emit('The report can\'t be exported before this Exchange\'s cutoff date.');
          window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
        } else {
          this.errorMessageCsvReport.emit('Internal server error');
        }
      }
    });
  }

  changeCsvOptions() {
    if (this.csvSelectedOption.exchange === 'Euronext' || this.csvSelectedOption.exchange === 'LME') {
      this.csvOptions = [{label: 'Final', value: 'Final'}];
      this.csvSelectedOption.mode = 'Final';
      return;
    }
    this.csvOptions = [{label: 'Draft', value: 'Draft'}, {label: 'Final', value: 'Final'}];
  }

  downLoadFile(data: any, fileName: string) {
    const blob = new Blob([data]);
    saveAs(blob, fileName);
  }

}
